export default __webpack_public_path__ + "static/media/shoes.effcc076.jpg";